// Сетка дашборда (GridStack). Создаётся один раз на загрузке модуля.

import { GridStack } from 'gridstack';

import { ensureAppShell } from './shell';

ensureAppShell();

GridStack.renderCB = (container, widget) => {
  container.classList.add('widget-card');
  if (widget.id) container.dataset.widgetId = String(widget.id);
  container.innerHTML = typeof widget.content === 'string' ? widget.content : '';
};

export const grid = GridStack.init(
  {
    column: 12,
    columnOpts: {
      breakpoints: [
        { w: 560, c: 1, layout: 'list' },
        { w: 900, c: 3, layout: 'list' },
        { w: 1120, c: 8, layout: 'moveScale' },
      ],
      layout: 'moveScale',
      breakpointForWindow: false,
    },
    cellHeight: 80,
    margin: 8,
    float: false,
    animate: true,
    minRow: 7,
    alwaysShowResizeHandle: 'mobile',
    draggable: {
      handle: '.widget-header',
      cancel: 'button, a, input, select, textarea, .maplibregl-control-container',
      scroll: true,
    },
    resizable: { handles: 'e, se, s, sw, w', autoHide: false },
  },
  '#dashboard-grid',
);
